import { motion } from 'framer-motion';
import './About.css';
import pathImg from './files/FW/path.png';
import momentumImg from './files/FW/momentum.png';
import familyImg from './files/FW/family.png';
import purposeImg from './files/FW/purpose.png';
import trustImg from './files/FW/trust.png';
import accountabilityImg from './files/FW/accountability.png';

const pageVariants = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 }
};

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.6
};

const frameworkItems = [
  { id: 'path', label: 'Path', image: pathImg },
  { id: 'momentum', label: 'Momentum', image: momentumImg },
  { id: 'family', label: 'Family', image: familyImg },
  { id: 'purpose', label: 'Purpose', image: purposeImg },
  { id: 'trust', label: 'Trust', image: trustImg },
  { id: 'accountability', label: 'Accountability', image: accountabilityImg }
];

function About() {
  return (
    <motion.section
      className="about section-container"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      <motion.div
        className="about-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        <h2 className="section-title">The York Framework</h2>
        <motion.div
          className="framework-items"
          initial="hidden"
          animate="show"
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.15 } }
          }}
        >
          {frameworkItems.map((item) => (
            <motion.div
              key={item.id}
              className="framework-item"
              variants={{
                hidden: { opacity: 0, y: -20 },
                show: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.5, ease: 'easeOut' }}
            >
              <img src={item.image} alt={item.label} />
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </motion.section>
  );
}

export default About;
